const POLL = 100;
const WAIT = 8000;

export const sleep = (ms: number) => new Promise((resolve) => window.setTimeout(resolve, ms));

export const waitFor = async <T>(probe: () => T | null | undefined, timeout = WAIT): Promise<T | null> => {
	for (let left = timeout; left > 0; left -= POLL) {
		const found = probe();
		if (found) return found;
		await sleep(POLL);
	}
	return null;
};

const isShown = (el: HTMLElement) => {
	const rect = el.getBoundingClientRect();
	return rect.width > 0 && rect.height > 0;
};

export const inView = (el: HTMLElement) => {
	const rect = el.getBoundingClientRect();
	return rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
};

export const visibleFirst = (els: HTMLElement[]) => els.find(inView) ?? els[0] ?? null;

const selector = (screen: string, element: string) => `[data-screen="${CSS.escape(screen)}"][data-el="${CSS.escape(element)}"]`;

export const find = (screen: string, element: string, scope: ParentNode = document) =>
	[...scope.querySelectorAll<HTMLElement>(selector(screen, element))].filter(isShown);

export const first = (screen: string, element: string) => find(screen, element)[0];

export const shownIn = (css: string) => [...document.querySelectorAll<HTMLElement>(css)].find(isShown) ?? null;

export const hasText = (el: Element, text: string) => ((el as HTMLElement).innerText ?? "").toLowerCase().includes(text.toLowerCase());

export const tap = (el: HTMLElement | null | undefined) => {
	if (!el) return;
	if (!inView(el)) el.scrollIntoView({ block: "center" });
	const rect = el.getBoundingClientRect();
	const top = document.elementFromPoint(rect.x + rect.width / 2, rect.y + rect.height / 2);
	(top instanceof HTMLElement && el.contains(top) ? top : el).click();
};

const ANCHOR: Record<string, string> = { main: "card", product_card: "card", cart: "list" };

export const isOpen = (screen: string) => {
	const anchor = ANCHOR[screen];
	if (anchor) return find(screen, anchor).length > 0;
	return [...document.querySelectorAll<HTMLElement>(`[data-screen="${CSS.escape(screen)}"]`)].some(isShown);
};
